import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavBar, DataTables, BreadCumb, TimeOut, WareHouseDetailsModal } from '../../components';
import { DISPATCH_ID, json, SERVICE_RESPONSE } from '../../libs/utils/Const';
import { ApiClient } from '../../libs/apiClient';
import config from '../../config';
import $ from 'jquery';
import { UserFields, WareHouseModel } from '../../components/NewOrder';
import { setUserFieldValue, setUserFieldValueDefault } from '../../libs/utils/GlobalFunc';
let apiClient = ApiClient.getInstance();

const headersDataTable = [
    { title: "#", value: true },
    { title: "Código", value: true },
    { title: "Nombre", value: true },
];

class WareHouseAdminView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')),
            data: [],
            newOrderModel: {},
            showWHSDetailsModal: false,
            action: 'new',
            configHeaderUserFields: [],


        }
    }

    componentDidMount = async () => {
        this.listWHS();
    }
    listWHS = async (search) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props
        enableSpinner(true);
        const listWHS = await apiClient.getListWareHouse();
        enableSpinner(false);

        if (listWHS.status === SERVICE_RESPONSE.SUCCESS) {
            this.setState({
                data: listWHS?.data ?? [],
            })
        } else {
            showAlert({ type: 'error', message: listWHS.message })
        }
    }
    fillWareHouseModel = (model, data) => {
        model.WhsCode = data?.WhsCode || '';
        model.WhsName = data?.WhsName || '';
        model.Inactive = data?.Inactive || 'tNO';
        model.DropShip = data?.DropShip || 'tNO';
        model.Location = data?.Location || '';
        model.Nettable = data?.Nettable || 'tYES';
        model.Street = data?.Street || '';
        model.StreetNo = data?.StreetNo || '';
        model.Block = data?.Block || '';
        model.Building = data?.Building || '';
        model.ZipCode = data?.ZipCode || '';
        model.City = data?.City || '';
        model.County = data?.County || '';
        model.Country = data?.Country || '';
        model.State = data?.State || '';
        model.FedTaxID = data?.FedTaxID || '';
        model.GlblLocNum = data?.GlblLocNum || '';
        model.TaxOffice = data?.TaxOffice || '';
        model.Address2 = data?.Address2 || '';
        model.Address3 = data?.Address3 || '';

        /**CUENTAS */
        model.ExpensesAc = data?.ExpensesAc || '';//Cta. gastos
        model.RevenuesAc = data?.RevenuesAc || '';//Cta. ingresos
        model.BalInvntAc = data?.BalInvntAc || '';//Cta. existencias
        model.SaleCostAc = data?.SaleCostAc || '';//Cta. costo de bienes ven.
        model.TransferAc = data?.TransferAc || '';//Cta. dotación
        model.VarianceAc = data?.VarianceAc || '';//Cta. desviación
        model.PriceDifAc = data?.PriceDifAc || '';//Cta. dif. precio
        model.NegStckAct = data?.NegStckAct || '';//Cta. ajuste de stock neg.
        model.DecreasAc = data?.DecreasAc || '';//Comp. stocks - Cta. reducción
        model.IncreasAc = data?.IncreasAc || '';//Comp. stocks - Cta. aumento
        model.ReturnAc = data?.ReturnAc || '';//Cta. devoluciones por ventas
        model.FrRevenuAc = data?.FrRevenuAc || '';//Cta. ingresos - Extranjero
        model.FrExpensAc = data?.FrExpensAc || '';//Cta. costos - Extranjero
        model.ExchangeAc = data?.ExchangeAc || '';//Cta. dif. tipo de cambio
        model.BalanceAcc = data?.BalanceAcc || '';//Cuenta comp. mercancías
        model.DecresGlAc = data?.DecresGlAc || '';//Cta. reducción del libro mayor
        model.IncresGlAc = data?.IncresGlAc || '';//Cta. aumento del libro mayor
        model.WipAcct = data?.WipAcct || '';//Cta. stocks trabajo curso
        model.WipVarAcct = data?.WipVarAcct || '';//Cta. desviación de stock WIP
        model.WipOffset = data?.WipOffset || '';//Cta. PyG de comp. WIP
        model.StockOffst = data?.StockOffst || '';//Cta. PyG de comp. de stocks
        model.StokRvlAct = data?.StokRvlAct || '';//Cta. de revalorización de stocks
        model.StkOffsAct = data?.StkOffsAct || '';//Cta. contrapartida de rev. inventario
        model.CostRvlAct = data?.CostRvlAct || '';//Cta. revaloración precio costo
        model.CstOffsAct = data?.CstOffsAct || '';//Rev. precio de costo - Cta. contrapartida
        model.ExpClrAct = data?.ExpClrAct || '';//Cta. comp. gastos
        model.StkInTnAct = data?.StkInTnAct || '';//Stock en cta. tránsito
        model.ShpdGdsAct = data?.ShpdGdsAct || '';//Cta. mercancías enviadas
        model.ARCMAct = data?.ARCMAct || '';//Cta.crédito ventas
        model.APCMAct = data?.APCMAct || '';//Cta.crédito compras
        model.ARCMFrnAct = data?.ARCMFrnAct || '';//Cta.crédito ventas: Extranjero
        model.APCMFrnAct = data?.APCMFrnAct || '';//Cta.crédito compras - Extranjero

        return model;
    }
    newWareHouse = async () => {
        const { enableSpinner } = this.props

        let newOrderModel = new WareHouseModel();
        let table = {
            name: 'OWHS',
        }
        enableSpinner(true)
        newOrderModel.userFields = await this.getUserFields(table);
        enableSpinner(false)

        this.setState({
            newOrderModel,
            showWHSDetailsModal: true,
            action: 'new',
        }, () => {
            $('#wareHouseDetailsModal').modal('show');
        })
    }
    getUserFields = async (table, header) => {
        const { enableSpinner } = this.props
        enableSpinner(true)
        let userFieldsResponse = await apiClient.getUserFields(table);
        enableSpinner(false)
        let userFieldsHeader = [];
        let userFieldsBody = [];
        if (userFieldsResponse.status === SERVICE_RESPONSE.SUCCESS) {
            userFieldsHeader = userFieldsResponse.data.header || [];
            userFieldsBody = userFieldsResponse.data.body || [];
        }
        let userFields = new UserFields();
        for (let index = 0; index < json.userFieldsWareHouse.length; index++) {
            const field = json.userFieldsWareHouse[index];
            for (let indez = 0; indez < userFieldsHeader.length; indez++) {
                const userfield = userFieldsHeader[indez];
                if (field.fieldId === userfield.header.FieldID) {
                    json.userFieldsWareHouse[index].name = userfield.header.Descr;
                    field.name = userfield.header.Descr;
                    field.fieldType = userfield.options.length != 0 ? 2 : 1;
                    field.options = userfield.options;
                    field.IdValue = index;
                    let newUserFields
                    if (header) {
                        newUserFields = setUserFieldValue(userFields, index, header);
                    } else {
                        newUserFields = setUserFieldValueDefault(userFields, index, userfield.header);
                    }

                    if (field.fieldType === 2) {
                        field.options.push({ FldValue: "", Descr: "" });
                    }
                    userFields = newUserFields;
                }
            }
        }
        this.setState({
            configHeaderUserFields: json.userFieldsWareHouse
        })

        return userFields
    }
    detailsWareHouse = async (wareHouse) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props
        const data = {
            WhsCode: wareHouse.WhsCode
        }
        enableSpinner(true);
        const details = await apiClient.getDetailsWareHouse(data);
        enableSpinner(false);

        if (details.status === SERVICE_RESPONSE.SUCCESS) {
            let newOrderModel = new WareHouseModel();
            newOrderModel = this.fillWareHouseModel(newOrderModel, details?.data ?? {});
            let table = {
                name: 'OWHS',
            }
            newOrderModel.userFields = await this.getUserFields(table, details?.data ?? {});

            this.setState({
                newOrderModel,
                showWHSDetailsModal: true,
                action: 'update',
            }, () => {
                $('#wareHouseDetailsModal').modal('show');
            })
        } else {
            showAlert({ type: 'error', message: details.message })
        }
    }
    refreshModel = newOrderModel => {
        this.setState({
            newOrderModel
        })
    }
    resetData = () => {
        this.setState({
            data: [],
            newOrderModel: {},
            showWHSDetailsModal: false,
            action: 'new',
        }, () => {
            this.listWHS();
        })
    }
    wareHouseAction = async (action) => {
        const { newOrderModel } = this.state
        const { enableSpinner, notificationReducer: { showAlert } } = this.props

        const data = {
            model: newOrderModel,
            action
        }
        enableSpinner(true);
        const responseAPI = await apiClient.wareHouseAction(data);
        enableSpinner(false);

        if (responseAPI.status === SERVICE_RESPONSE.SUCCESS) {
            showAlert({ type: 'success', message: responseAPI.message })
            $('#wareHouseDetailsModal').modal('hide');
            this.resetData()
        } else {
            showAlert({ type: 'error', message: responseAPI.message })
        }
    }
    openConfigUserFieldsHeaders = () => {

        let userFields = json.userFieldsWareHouse
        this.setState({
            configHeaderUserFields: userFields,
        }, () => {
            $('#configUserFieldsModal').modal({ backdrop: 'static', keyboard: false }, 'show');
        })

    }
    render() {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props
        const { _user, data, newOrderModel, showWHSDetailsModal, action, configHeaderUserFields } = this.state
        return (
            <div className="content">
                <NavBar props={this.props} _user={_user} />
                <TimeOut />
                <BreadCumb subitem1={'ADMINISTRACIÓN DE ALMACENES'} url1={'#'} />

                <div style={{ marginLeft: "4rem", marginBottom: "12rem" }}>
                    <h2 className="md-display-1">
                        <a href=" " id="wareHouseAdmin" className="text-muted">
                            &nbsp;ADMINISTRACIÓN DE ALMACENES
                        </a>
                    </h2>
                    <DataTables
                        headers={headersDataTable}
                        view={"wareHouseAdmin"}
                        data={data}
                        search={this.listWHS}
                        openDetails={this.detailsWareHouse}
                        details={newOrderModel}
                        viewAction={this.newWareHouse}
                    />
                </div>
                {showWHSDetailsModal &&
                    <WareHouseDetailsModal
                        action={action}
                        newOrderModel={newOrderModel}
                        refreshModel={this.refreshModel}
                        enableSpinner={enableSpinner}
                        showAlert={showAlert}
                        resetData={this.resetData}
                        wareHouseAction={this.wareHouseAction}
                        view={"wareHouseAdmin"}
                        configHeaderUserFields={configHeaderUserFields}
                        openConfigUserFieldsHeaders={this.openConfigUserFieldsHeaders}
                    />
                }
            </div>
        );
    }
}

const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value })
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(WareHouseAdminView);
